import { createContext, useContext } from "react";
import type { Session, User } from "@supabase/supabase-js";

export interface AuthContextValue {
  user: User | null;
  session: Session | null;
  loading: boolean;
  signIn: (email: string, password: string) => Promise<{ error?: string }>;
  signUp: (email: string, password: string) => Promise<{ error?: string; needsConfirm?: boolean }>;
  signOut: () => Promise<void>;
  getToken: () => Promise<string | null>;
  requestPasswordReset: (email: string) => Promise<{ error?: string }>;
}

export const AuthContext = createContext<AuthContextValue>(null!);

export const useAuth = () => useContext(AuthContext);
